<template lang="pug">
  div
    h1 Sample
    div {{ msg }}{{ count }}
    button.btn.btn-info(@click='sub') -
    button.btn.btn-info(@click='add') +
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
    name: "Sample",
    data: () => {
        return { msg : 'Counter ' }
    },
    created: () => {
        console.log('sample page created');
    },
    computed: {
        ...mapState(["count"])
    },
    methods: {
        ...mapMutations([
            'increment',
            'decrement'
        ]),
        ...mapActions([
        ]),
        add() {
            this.increment()
        },
        sub() {
            this.decrement()
        }
    }
}
</script>